import { render, staticRenderFns } from "./add-tour.vue?vue&type=template&id=1c5d47f0&scoped=true&"
import script from "./add-tour.vue?vue&type=script&lang=js&"
export * from "./add-tour.vue?vue&type=script&lang=js&"
import style0 from "./add-tour.vue?vue&type=style&index=0&id=1c5d47f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5d47f0",
  null
  
)

export default component.exports